import { DASHBOARD_LINK } from '@components/Router/constants'
import { useRedirectAfterAuth } from '@components/Router/hooks/useRedirectAfterAuth'
import type React from 'react'
import { Navigate } from 'react-router-dom'

import { useAuth } from '@/hooks'
import { Main } from './Main'

export const AuthenticatedMain: React.FC = () => {
  const { authenticated, setupCompleted } = useAuth()

  useRedirectAfterAuth()

  if (authenticated && setupCompleted) {
    return <Navigate to={DASHBOARD_LINK} />
  }

  return <Main />
}
